import React, { memo, useEffect, useState } from "react";
import { Dialog, DialogContent } from "./dialog";
import { Button } from "./button";
import { CircleX } from "lucide-react";
import ExportList from "./export-list";

const ExportModal = ({
  list = [],
  open = false,
  onCancel = () => null,
  onAccept = () => null,
  header = "header",
  containerRef,
  isSubmitting = false,
  cancelText = "Cancel",
  acceptText = "OK",
  children,
}) => {
  const [exportList, setExportList] = useState(list);

  useEffect(() => {
    setTimeout(() => {
      setExportList(list);
    }, 100);
  }, [JSON.stringify(list + ""), open]);
  return (
    <Dialog open={open}>
      <DialogContent
        containerRef={containerRef}
        className="max-w-md max-h-[90vh] overflow-y-auto [&_*]:!font-sans"
      >
        <div className="flex flex-col gap-7">
          <div className="flex items-center justify-between">
            <h4 className="text-md font-semibold">{header}</h4>
            <Button
              id="modal-close"
              onClick={onCancel}
              className="rounded-full bg-transparent p-0 h-auto shadow-none hover:bg-transparent"
            >
              <CircleX className="!w-6 !h-6 text-form-label" />
            </Button>
          </div>
          <div>
            <h3 className="text-sm mb-2">
              Choose which columns you’d like to export.
            </h3>
            <ExportList
              list={exportList}
              containerRef={containerRef}
              loading={isSubmitting}
              onClick={(item, index) =>
                setExportList((prevList) =>
                  prevList.map((prevItem, i) =>
                    i === index
                      ? { ...prevItem, checked: !prevItem.checked }
                      : prevItem
                  )
                )
              }
            />
          </div>

          {children}
          <div className="flex flex-row justify-center items-center gap-3">
            <Button
              id="modal-cancel-button"
              onClick={onCancel}
              disabled={isSubmitting}
              className="px-6 py-4 text-lg font-normal"
              variant="destructive"
            >
              <h5 className="text-sm font-semibold">{cancelText}</h5>
            </Button>
            <Button
              id="modal-confirm-button"
              onClick={() =>
                onAccept(exportList.filter((item) => item.checked))
              }
              disabled={
                isSubmitting ||
                exportList.filter((item) => item.checked).length === 0
              }
              className="px-6 py-4 !bg-primary"
            >
              <h5 className="text-sm font-semibold">{acceptText}</h5>
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(ExportModal);
